const sofortCountries = [
  'AT','BE','DE','IT','ES','NL'
];

export default sofortCountries;


// WEBPACK FOOTER //
// ./src/constants/sofort-countries.js